<div class="page-head">
  <div>
    <p class="eyebrow">งานขาย</p>
    <h1>รายการจองเหมากรุ๊ป</h1>
    <p>ติดตามรายการจองเหมากรุ๊ป ยอดรับ การเบิกจ่าย และสถานะการเดินทาง</p>
  </div>
  @if (canManageBooking()) {
    <button
      type="button"
      class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 active:scale-[0.98]"
      (click)="openGroupBookingModal()"
    >
      <lucide-icon name="Plus" [size]="17" />
      สร้าง ทัวร์เหมากรุ๊ป
    </button>
  }
</div>
<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #bookingsTable
    [value]="bookings()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="[
      'code',
      'tourCode',
      'tripName',
      'countryName',
      'customerName',
      'customerCode',
      'bookingStatus',
      'paymentStatus',
    ]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '980px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <label class="relative block w-full max-w-md"
        ><lucide-icon
          name="Search"
          [size]="17"
          class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400" /><input
          pInputText
          #bookingQuery
          class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหา Booking ลูกค้า หรือทริป"
          (input)="bookingsTable.filterGlobal(bookingQuery.value, 'contains')" /></label>
      <app-refresh-button
        class="self-end sm:self-auto"
        label="รีเฟรชรายการจองเหมากรุ๊ป"
        [loading]="isLoadingBookings()"
        (refresh)="loadGroupBookingPageData()"
      />
      </div>
    </ng-template>
    <ng-template #header
      ><tr>
        <th class="w-14 text-center text-xs whitespace-nowrap">ลำดับ</th>
        <th pSortableColumn="code" class="w-44 text-xs whitespace-nowrap">
          Booking <p-sortIcon field="code" />
        </th>
        <th pSortableColumn="tripName" class="min-w-80 text-xs whitespace-nowrap">
          ทัวร์และการเดินทาง <p-sortIcon field="tripName" />
        </th>
        <th pSortableColumn="customerName" class="min-w-48 text-xs whitespace-nowrap">
          ลูกค้า <p-sortIcon field="customerName" />
        </th>
        <th pSortableColumn="total" class="w-48 text-right text-xs whitespace-nowrap">
          สรุปยอด <p-sortIcon field="total" />
        </th>
        <th class="w-52 text-xs whitespace-nowrap">สถานะ</th>
        <th class="w-32 text-right text-xs whitespace-nowrap">ดำเนินการ</th>
      </tr></ng-template
    >
    <ng-template #body let-row let-rowIndex="rowIndex"
      ><tr class="transition even:bg-slate-50/40 hover:bg-sky-50/60">
        <td class="py-3.5 text-center text-[13px] text-slate-400 tabular-nums align-top">
          {{ rowIndex + 1 }}
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">{{ row.code }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">รหัสทัวร์ {{ row.tourCode || '—' }}</p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold leading-5 text-slate-800">{{ row.tripName }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            {{ row.countryName }} · {{ row.travelDate | date: 'dd MMM yyyy' }}
            @if (row.returnDate) {
              – {{ row.returnDate | date: 'dd MMM yyyy' }}
            }
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            ผู้เดินทาง {{ row.travelerCount | number }} คน
          </p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-medium leading-5 text-slate-700">{{ row.customerName }}</p>
          <p class="mt-1 mb-0 text-xs font-medium text-sky-700">{{ row.customerCode }}</p>
        </td>
        <td class="py-3.5 text-right align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800 tabular-nums">
            {{ row.total | number: '1.2-2' }} บาท
          </p>
        </td>
        <td class="py-3.5 align-top">
          <div class="grid gap-2">
            <div class="flex items-center gap-2">
              <span class="w-14 shrink-0 text-xs text-slate-500">การจอง</span>
              <app-status-badge [status]="row.bookingStatus" />
            </div>
            <div class="flex items-center gap-2">
              <span class="w-14 shrink-0 text-xs text-slate-500">ชำระเงิน</span>
              <app-status-badge [status]="row.paymentStatus" />
            </div>
          </div>
        </td>
        <td class="py-3.5 align-top">
          <div class="flex justify-end gap-1.5">
            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
              title="ดูรายละเอียด"
              (click)="viewGroupBooking(row.id)"
            >
              <lucide-icon name="Eye" [size]="15" /></button
            >
            @if (canModifyGroupBooking(row)) {
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
                title="แก้ไข"
                [disabled]="row.bookingStatus === 'DELETED'"
                (click)="openEditGroupBookingModal(row)"
              >
                <lucide-icon name="Pencil" [size]="15" />
              </button>
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-red-200 bg-white p-0 text-red-600 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
                title="ลบ"
                [disabled]="row.bookingStatus === 'DELETED'"
                (click)="deleteGroupBooking(row)"
              >
                <lucide-icon name="Trash2" [size]="15" />
              </button>
            }
          </div>
        </td></tr
    ></ng-template>
    <ng-template #emptymessage
      ><tr>
        <td colspan="7">
          <div class="empty">
            <h3>ไม่พบรายการจอง</h3>
            <p>ลองเปลี่ยนคำค้นหา</p>
          </div>
        </td>
      </tr></ng-template
    >
  </p-table>
</section>

@if (isBookingModalOpen()) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeGroupBookingModal()"
  >
    <section
      class="my-auto w-full max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-booking-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            ข้อมูลการจอง
          </p>
          <h2 id="add-booking-title" class="m-0 text-xl font-bold text-slate-800">
            {{ editingBookingId() ? 'แก้ไข Booking' : 'สร้าง Booking ใหม่' }}
          </h2>
          <p class="mt-1 mb-0 text-sm text-slate-500">กรอกรายละเอียดลูกค้า โปรแกรม และการเดินทาง</p>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeGroupBookingModal()"
        >
          <lucide-icon name="X" [size]="19" aria-hidden="true" />
        </button>
      </div>

      <form [formGroup]="bookingForm" (ngSubmit)="saveGroupBooking()">
        <div
          class="max-h-[68vh] space-y-5 overflow-y-auto px-5 py-5 sm:px-6"
        >
          <section class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 sm:p-5">
            <div class="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
              <span class="grid size-9 place-items-center rounded-lg bg-sky-100 text-sky-700">
                <lucide-icon name="BriefcaseBusiness" [size]="18" aria-hidden="true" />
              </span>
              <div>
                <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลทัวร์</h3>
                <p class="mt-0.5 mb-0 text-xs text-slate-500">ระบุลูกค้า โปรแกรม ราคา และช่วงวันเดินทาง</p>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-x-6 gap-y-0 md:grid-cols-2">
          <div class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>ชื่อลูกค้า <span class="text-red-500">*</span></span>
            <p-select
              class="h-11 w-full font-normal"
              formControlName="customerId"
              [options]="customerOptions()"
              optionLabel="label"
              optionValue="value"
              placeholder="เลือกลูกค้า"
              [filter]="true"
              filterBy="label"
            />
            <span class="min-h-4">
              @if (isInvalid('customerId')) {
                <small class="font-normal text-red-600">กรุณาเลือกลูกค้า</small>
              }
            </span>
            @if (!editingBookingId()) {
              <div class="flex items-center gap-2 rounded-lg border border-sky-100 bg-sky-50 px-3 py-2 mb-5">
                <p-checkbox
                  inputId="customer-is-traveler"
                  formControlName="customerIsTraveler"
                  [binary]="true"
                />
                <label for="customer-is-traveler" class="cursor-pointer text-sm font-medium text-slate-700 ">
                  ลูกค้ารายนี้เป็นสมาชิกทัวร์ด้วย
                </label>
              </div>
            }
          </div>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>รหัสทัวร์ <span class="text-red-500">*</span></span>
            <p-select
              class="h-11 w-full font-normal"
              formControlName="tourCode"
              [options]="tourCodeOptions()"
              optionLabel="label"
              optionValue="value"
              placeholder="ค้นหารหัสทัวร์"
              [filter]="true"
              filterBy="label,value"
              [showClear]="true"
              (onChange)="onGroupTourSelected($event.value)"
            />
            <span class="min-h-4">
              @if (isInvalid('tourCode')) {
                <small class="font-normal text-red-600">กรุณากรอกรหัสทัวร์</small>
              }
            </span>
          </label>

          <label hidden
            class="grid content-start gap-1 text-sm font-semibold text-slate-700 md:col-span-2"
          >
            <span>ชื่อโปรแกรม <span class="text-red-500">*</span></span>
            <input
              pInputText
              class="h-11 w-full font-normal"
              formControlName="programName"
              placeholder="เช่น ญี่ปุ่น โตเกียว ฟูจิ 6 วัน"
            />
            <span class="min-h-4">
              @if (isInvalid('programName')) {
                <small class="font-normal text-red-600">กรุณากรอกชื่อโปรแกรม</small>
              }
            </span>
          </label>

          <label hidden class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>ประเทศ <span class="text-red-500">*</span></span>
            <p-select
              class="h-11 w-full font-normal"
              formControlName="country"
              [options]="countryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="เลือกประเทศ"
              [filter]="true"
              filterBy="label"
            />
            <span class="min-h-4">
              @if (isInvalid('country')) {
                <small class="font-normal text-red-600">กรุณาเลือกประเทศ</small>
              }
            </span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>จำนวนคน <span class="text-red-500">*</span></span>
            <p-inputnumber
              class="w-full font-normal"
              inputStyleClass="h-11 w-full"
              formControlName="travelerCount"
              [min]="1"
              [showButtons]="true"
              buttonLayout="horizontal"
            >
              <ng-template #decrementbuttonicon>
                <lucide-icon name="Minus" [size]="16" aria-hidden="true" />
              </ng-template>
              <ng-template #incrementbuttonicon>
                <lucide-icon name="Plus" [size]="16" aria-hidden="true" />
              </ng-template>
            </p-inputnumber>
            <span class="min-h-4">
              @if (isInvalid('travelerCount')) {
                <small class="font-normal text-red-600">จำนวนคนต้องไม่น้อยกว่า 1</small>
              }
              @if (groupTourCapacityExceeded()) {
                <small class="font-normal text-red-600">จำนวนคนเกินที่ว่างของทัวร์ กรุณาลดจำนวนคน</small>
              }
            </span>
            @if (groupTourRemainingPax() !== null) {
              <small class="font-normal text-slate-500">
                ทัวร์ยังขาดอีก {{ groupTourRemainingPax() }} คน
              </small>
            }
          </label>

          <label hidden class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>วันเดินทางไป <span class="text-red-500">*</span></span>
            <p-datepicker
              class="w-full font-normal"
              formControlName="departureDate"
              dateFormat="dd/mm/yy"
              placeholder="เลือกวันเดินทางไป"
              [showIcon]="true"
              [readonlyInput]="true"
              appendTo="body"
            />
            <span class="min-h-4">
              @if (isInvalid('departureDate')) {
                <small class="font-normal text-red-600">กรุณาเลือกวันเดินทางไป</small>
              }
            </span>
          </label>

          <label hidden class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>วันเดินทางกลับ <span class="text-red-500">*</span></span>
            <p-datepicker
              class="w-full font-normal"
              formControlName="returnDate"
              dateFormat="dd/mm/yy"
              placeholder="เลือกวันเดินทางกลับ"
              [showIcon]="true"
              [readonlyInput]="true"
              appendTo="body"
            />
            <span class="min-h-4">
              @if (isInvalid('returnDate')) {
                <small class="font-normal text-red-600">กรุณาเลือกวันเดินทางกลับ</small>
              }
            </span>
          </label>

          <label hidden class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>ราคาทัวร์ <span class="text-red-500">*</span></span>
            <p-inputnumber
              class="w-full font-normal"
              inputStyleClass="h-11 w-full"
              formControlName="tourPrice"
              mode="currency"
              currency="THB"
              locale="th-TH"
              [min]="0"
              placeholder="0.00"
            />
            <span class="min-h-4">
              @if (isInvalid('tourPrice')) {
                <small class="font-normal text-red-600">กรุณากรอกราคาทัวร์</small>
              }
            </span>
          </label>

          <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
            <span>ส่วนลดทั้งหมด</span>
            <p-inputnumber
              class="w-full font-normal"
              inputStyleClass="h-11 w-full"
              formControlName="discount"
              mode="currency"
              currency="THB"
              locale="th-TH"
              [min]="0"
              placeholder="0.00"
            />
            <small class="text-gray-500">ยอดส่วนลดรวมทั้ง Booking</small>
            <span class="min-h-4">
              @if (bookingForm.hasError('discountExceeded')) {
                <small class="font-normal text-red-600">
                  ส่วนลดทั้งหมดต้องไม่เกินราคาทัวร์ทั้งหมด
                </small>
              }
            </span>
          </label>

            </div>
          </section>

          <section class="rounded-xl border border-slate-200 bg-slate-50/60 p-4 sm:p-5">
            <div class="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
              <span class="grid size-9 place-items-center rounded-lg bg-emerald-100 text-emerald-700">
                <lucide-icon name="Map" [size]="18" aria-hidden="true" />
              </span>
              <div>
                <h3 class="m-0 text-base font-bold text-slate-800">รายละเอียดทัวร์</h3>
                <p class="mt-0.5 mb-0 text-xs text-slate-500">ข้อมูลจากทัวร์ที่เลือก</p>
              </div>
            </div>
            @if (isLoadingTour()) {
              <div class="grid min-h-28 place-items-center rounded-lg border border-dashed border-slate-300 bg-white p-6 text-center">
                <p class="m-0 text-sm text-slate-400">กำลังโหลดข้อมูลทัวร์...</p>
              </div>
            } @else if (selectedTour(); as tour) {
              <dl class="grid gap-4 rounded-lg border border-slate-200 bg-white p-4 sm:grid-cols-2 lg:grid-cols-3">
                <div>
                  <dt class="text-xs text-slate-500">เลขที่ทัวร์</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourNo }}</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">รหัสทัวร์</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourCode }}</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">ชื่อทัวร์</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourName }}</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">ประเทศ / จุดหมาย</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.country }}</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">ประเภททัวร์</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourType }}</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">สถานะ</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.status }}</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">วันเดินทาง</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">
                    {{ tour.travelDate | date: 'dd/MM/yyyy' }}
                    @if (tour.returnDate) {
                      – {{ tour.returnDate | date: 'dd/MM/yyyy' }}
                    }
                  </dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">จำนวนผู้เดินทาง</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.requiredPax ?? '-' }} คน</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">ราคาทัวร์</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourprice | number: '1.2-2' }} บาท</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">ยอดรวมทัวร์</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourTotalAmount | number: '1.2-2' }} บาท</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">คอมมิชชั่นฝ่ายขาย</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.com_sale | number: '1.2-2' }} บาท</dd>
                </div>
                <div>
                  <dt class="text-xs text-slate-500">คอมมิชชั่นผู้ดูแล</dt>
                  <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.com_admintrator | number: '1.2-2' }}%</dd>
                </div>
              </dl>
            } @else {
              <div class="grid min-h-28 place-items-center rounded-lg border border-dashed border-slate-300 bg-white p-6 text-center">
                <p class="m-0 text-sm text-slate-400">กรุณาเลือกทัวร์เพื่อดูรายละเอียด</p>
              </div>
            }
          </section>

        </div>

        <div
          class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
        >
          <button
            type="button"
            class="tw-button rounded-xl border border-slate-300 bg-white px-5 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-100"
            (click)="closeGroupBookingModal()"
          >
            ยกเลิก
          </button>
          <button
            type="submit"
            class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-5 py-2.5 font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] disabled:cursor-not-allowed disabled:opacity-50"
            [disabled]="isSavingGroupBooking() || isLoadingTour()"
          >
            <lucide-icon name="Check" [size]="18" aria-hidden="true" />
            {{
              isSavingGroupBooking()
                ? 'กำลังบันทึก...'
                : editingBookingId()
                  ? 'บันทึกการแก้ไข'
                  : 'บันทึกรายการ'
            }}
          </button>
        </div>
      </form>
    </section>
  </div>
}
